import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Route, Switch, withRouter} from "react-router-dom";
import TestTemplates from "./TestTemplates";
import TestTemplateDetails from "./TestTemplateDetails";

function mapStateToProps(state) {
  return {};
}

class TestTemplatesIndex extends Component {
  render() {
    return (
      <Switch>
        <Route component={TestTemplateDetails} path="/test-templates/:guid"/>
        <Route component={TestTemplates} path="/test-templates"/>
      </Switch>
    );
  }
}

export default withRouter(connect(
  mapStateToProps,
)(TestTemplatesIndex));
